import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Utils } from 'src/app/shared/utils/utils';
import { Subscription } from 'rxjs';
import { BankerService } from '../shared/services/banker.service';

@Component({
  selector: 'app-form-banker',
  templateUrl: './form-banker.component.html',
  styleUrls: ['./form-banker.component.css']
})
export class FormBankerComponent implements OnInit {
  banker: any = {
    name: '',
    email: '',
    phone: '',
    bank_name: '',
    availabilities: []
  };
  isEditMode = false;
  submitted = false;
  busy: Subscription;
  bankerId: number = null;

  constructor(
    private bankerService: BankerService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      const id = params.get('id');
      if (id) {
        this.isEditMode = true;
        this.bankerId = +id;
        this.loadBanker(this.bankerId);
      } else {
        this.banker.availabilities.push({
          date: this.getTodayDate(),
          start_time: '09:00',
          end_time: '12:00',
          interval_minutes: 30
        });
      }
    });
  }

  loadBanker(id: number) {
    this.busy = this.bankerService.getBankerById(id).subscribe(
      data => {
        this.banker = data;
      },
      error => {
        Utils.sweetAlert('error', 'Erreur', 'Impossible de charger le banquier');
      }
    );
  }

  submitForm() {
    this.submitted = true;
  
    if (!this.banker.name || !this.banker.email) {
      Utils.sweetAlert('error', 'Erreur', 'Veuillez remplir les champs requis');
      return;
    }
  
    
  
    if (this.isEditMode) {
      // Normaliser les heures start_time et end_time pour chaque disponibilité
    this.banker.availabilities.forEach((availability: any) => {
      if (availability.start_time && availability.start_time.length === 5) {
        availability.start_time += ':00';
      }
      if (availability.end_time && availability.end_time.length === 5) {
        availability.end_time += ':00';
      }
    });
      this.busy = this.bankerService.updateBanker(this.bankerId, this.banker).subscribe(
        () => {
          Utils.sweetAlert('success', 'Succès', 'Banquier modifié avec succès');
          this.router.navigate(['/list-bankers']);
        },
        error => {
          Utils.sweetAlert('error', 'Erreur', 'Erreur lors de la modification');
        }
      );
    } else {
      this.busy = this.bankerService.addBanker(this.banker).subscribe(
        () => {
          Utils.sweetAlert('success', 'Succès', 'Banquier ajouté avec succès');
          this.router.navigate(['/list-bankers']);
        },
        error => {
          Utils.sweetAlert('error', 'Erreur', 'Erreur lors de l\'ajout du banquier');
        }
      );
    }
  }
  
  addAvailability() {
    this.banker.availabilities.push({
      date: this.getTodayDate(),
      start_time: '09:00',
      end_time: '12:00',
      interval_minutes: 30
    });
  }

  removeAvailability(index: number) {
    this.banker.availabilities.splice(index, 1);
  }

  private getTodayDate(): string {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = (today.getMonth() + 1).toString().padStart(2, '0');
    const dd = today.getDate().toString().padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  }
}
